import React, { useState } from "react";
import { useJourney } from "@/context/JourneyContext";
import { api } from "@/lib/api";
import { Plus, FolderOpen, Check } from "lucide-react";

export function JourneyBar() {
  const { session, resume, setSession, setStage } = useJourney();
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);

  const toggle = async () => {
    const nextOpen = !open;
    setOpen(nextOpen);
    if (nextOpen) {
      try { setList(await api.listSessions()); } catch { /* ignore */ }
    }
  };

  const newJourney = () => {
    // Current journey is already auto-saved in Mongo; just reset to the Welcome screen.
    setSession(null);
    setStage(0);
    setOpen(false);
  };

  const resumeSession = async (id) => {
    await resume(id);
    setOpen(false);
  };

  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2" data-testid="journey-bar">
      <button
        data-testid="journey-new-btn"
        onClick={newJourney}
        className="flex items-center gap-1.5 rounded-full border border-line bg-surface/85 px-4 py-2 text-xs font-medium text-forest backdrop-blur transition hover:bg-surface"
      >
        <Plus size={14} /> New journey
      </button>
      <div className="relative">
        <button
          data-testid="journey-open-btn"
          onClick={toggle}
          className="flex items-center gap-1.5 rounded-full border border-line bg-surface/85 px-4 py-2 text-xs font-medium text-forest backdrop-blur transition hover:bg-surface"
        >
          <FolderOpen size={14} /> Journeys
        </button>
        {open && (
          <div
            data-testid="journey-list"
            className="absolute left-1/2 mt-2 w-72 max-h-80 -translate-x-1/2 overflow-y-auto rounded-2xl border border-line bg-surface p-2 shadow-2xl"
          >
            {list.length === 0 ? (
              <p className="p-3 text-xs text-mutedText">No saved journeys yet.</p>
            ) : (
              list.map((s) => (
                <button
                  key={s.id}
                  data-testid={`journey-item-${s.id}`}
                  onClick={() => resumeSession(s.id)}
                  className={`flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm transition hover:bg-white/5 ${session?.id === s.id ? "bg-brand/10 text-brand" : "text-forest"}`}
                >
                  <span>
                    <span className="block font-medium">{s.client_name || "Untitled"}</span>
                    <span className="block text-[11px] text-mutedText">with {s.consultant_name} · stage {s.current_stage}/10</span>
                  </span>
                  {session?.id === s.id && <Check size={15} className="shrink-0 text-brand" />}
                </button>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}
